var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDensityCompact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.54545C5 9.24421 5.24421 9 5.54545 9H18.4545C18.7558 9 19 9.24421 19 9.54545V9.54545C19 9.8467 18.7558 10.0909 18.4545 10.0909H5.54545C5.24421 10.0909 5 9.8467 5 9.54545V9.54545Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.172C5 10.8653 5.24862 10.6166 5.55531 10.6166H18.4447C18.7514 10.6166 19 10.8653 19 11.172V11.172C19 11.4787 18.7514 11.7273 18.4447 11.7273H5.55531C5.24862 11.7273 5 11.4787 5 11.172V11.172Z",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.8182C5 12.5169 5.24421 12.2727 5.54545 12.2727H18.4545C18.7558 12.2727 19 12.5169 19 12.8182V12.8182C19 13.1194 18.7558 13.3636 18.4545 13.3636H5.54545C5.24421 13.3636 5 13.1194 5 12.8182V12.8182Z",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.4545C5 14.1533 5.24421 13.9091 5.54545 13.9091H18.4545C18.7558 13.9091 19 14.1533 19 14.4545V14.4545C19 14.7558 18.7558 15 18.4545 15H5.54545C5.24421 15 5 14.7558 5 14.4545V14.4545Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensityCompact);
export default __webpack_public_path__ + "static/media/density-compact.6135cd19db5cba43c2c866ada290b765.svg";
export { ForwardRef as ReactComponent };